import React from 'react';
export default function Pagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-white">
      <p className="text-sm text-gray-600">Page <b>{page + 1}</b> of <b>{totalPages}</b></p>
      <div className="flex gap-2">
        <button onClick={() => onPageChange(page - 1)} disabled={page === 0} className="px-3 py-1 text-sm border rounded-lg disabled:opacity-40 hover:bg-gray-50">Prev</button>
        <button onClick={() => onPageChange(page + 1)} disabled={page >= totalPages - 1} className="px-3 py-1 text-sm border rounded-lg disabled:opacity-40 hover:bg-gray-50">Next</button>
      </div>
    </div>
  );
}
